// extracted by mini-css-extract-plugin
export default {"button_container":"ThankYouMessage_button_container__NCPdt","popup_container":"ThankYouMessage_popup_container__adZHX"};